import type { IconData } from '@stacksjs/iconify-core'

export const exitToApp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 16H40a24.03 24.03 0 0 0-24 24v160h32V48h416v416H48V304H16v168a24.03 24.03 0 0 0 24 24h432a24.03 24.03 0 0 0 24-24V40a24.03 24.03 0 0 0-24-24\"/><path fill=\"currentColor\" d=\"m209.377 363.306l22.627 22.627L366.627 251.31L232.004 116.687l-22.627 22.626l95.997 95.998H16v32h289.372z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default exitToApp
